// extracted by mini-css-extract-plugin
export var label = "_fo-2";
export var slideContainer = "_fo-0";
export var slider = "_fo-1";